import UploadLogRow from 'features/PMSLogs/LogRow'
import moment from 'moment'
import { useState } from 'react'

import styles from './DayRow.module.scss'

const UploadLogsDayRow = ({ logGroup, handleDownloadData, isAdminMode }) => {
  const [isExpanded, setExpanded] = useState(false)

  return (
    <div className={isExpanded ? styles.container : ''}>
      <div className={styles.row} onClick={() => setExpanded(!isExpanded)}>
        <div className={styles.date}>{moment(logGroup.date).format('MMM D')}</div>
        <div className={styles.totalUpload}>
          {logGroup.logs.reduce(
            (prev, current) => prev + current.numberOfNewSubscribers,
            0
          )}{' '}
          subscribers, {logGroup.logs.length} logs
        </div>
        {isExpanded && (
          <>
            <div className={styles.col}>Records</div>
            <div className={styles.col}>New</div>
            <div className={styles.col}>Updates</div>
            <div className={styles.col}>Dupes</div>
            <div className={styles.col}>Invalid</div>
          </>
        )}
        <div className={styles.control}>
          <i></i>
        </div>
      </div>
      {isExpanded &&
        logGroup.logs.map(log => (
          <UploadLogRow
            {...log}
            key={log.id}
            handleDownloadData={handleDownloadData}
            isAdminMode={isAdminMode}
          />
        ))}
    </div>
  )
}

export default UploadLogsDayRow
